import { COMMISSION_PLANS, COMMISSION_PLAN_LABEL, type CommissionPlan } from '@shared/fees'
import { useStore } from '../../store'
import { cn } from '../../lib/utils'

const RATE_TEXT: Record<CommissionPlan, string> = {
  fixed: '$0.005 a share, at least $1.00 an order (at most 1% of its value). SEC / FINRA fees on sales.',
  tiered: '$0.0035 a share, at least $0.35 an order, plus exchange and clearing fees (≈ $0.003 a share). SEC / FINRA fees on sales.',
  robinhood: 'No commission. SEC / FINRA fees on larger sales.',
}

/** Which IBKR Pro plan the worker and order cards use for their after-fee numbers. */
export function CommissionSettings() {
  const settings = useStore((s) => s.settings)
  const update = useStore((s) => s.updateSettings)
  if (!settings) return null
  const plan = settings.commissionPlan ?? 'fixed'
  return (
    <section id="settings-commissions" className="card p-4">
      <h2 className="text-[14px] font-semibold text-fg">Commissions</h2>
      <p className="mt-0.5 text-[12.5px] text-fg-subtle">
        Worker and order cards show every result after fees, estimated for your IBKR Pro plan. The paper account is on Fixed; your live
        account’s plan is in IBKR Client Portal.
      </p>
      <div className="mt-3 inline-flex rounded-lg border border-[var(--line-soft)] p-0.5">
        {COMMISSION_PLANS.map((p) => (
          <button
            key={p}
            onClick={() => void update({ commissionPlan: p })}
            className={cn(
              'rounded-md px-4 py-1.5 text-[12.5px] font-medium transition-colors',
              plan === p ? 'bg-[var(--color-surface-3)] text-fg' : 'text-fg-subtle hover:text-fg',
            )}
          >
            {COMMISSION_PLAN_LABEL[p]}
          </button>
        ))}
      </div>
      <p className="mt-2 text-[12px] text-fg-faint">{RATE_TEXT[plan]} Applies to cards drawn from now on.</p>
    </section>
  )
}
